import React, { useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import { MODAL_INDICATOR_CANVAS_ID } from "components/atoms/chart/logic/chartConfig"
import { useIndicatorChartInitialize } from "components/atoms/chart/parts/useChartInitialize"
import IndicatorChart from "components/atoms/chart/parts/IndicatorChart"
import { Modal } from "react-bootstrap"
import { spIndicatorChartModal } from "redux/ducks/IndicatorChart"
import { IndicatorChartLegFilter } from "components/atoms/chart/parts/ChartLegFilter"
import { InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import { getCountryIcon } from "utils/util"
import { get, pick } from "lodash"
import * as Formatter from "utils/Formatter"
import ClassNames from "classnames"

const SpIndicatorChart = () => {
  const dispatch = useDispatch()
  const canvasId = useIndicatorChartInitialize(MODAL_INDICATOR_CANVAS_ID)
  const indicatorChartSelector = (state: any) => state.indicatorChart[canvasId]
  const indicatorChart = useSelector(indicatorChartSelector)
  const isVisible = get(indicatorChart, "modalVisible")
  const symbolDetail = pick(indicatorChart, [
    "ID",
    "TargetDate",
    "DisplayName",
    "AnnouncedAt",
    "DisplayTargetDate",
    "ActualText",
    "SurveyText",
    "RevisedPriorText",
    "CountryCode",
  ])
  const onHide = () => {
    dispatch(spIndicatorChartModal(false))
  }

  const icon = useMemo(() => {
    return getCountryIcon(indicatorChart)
  }, [indicatorChart])

  return (
    <Modal
      show={isVisible}
      onHide={() => onHide()}
      dialogClassName="sp-indicator-chart-modal"
    >
      <Modal.Body>
        <div className="modal-body-content">
          <div className="modal-body-items">
            <div className="symbol-name-group">
              <i className={ClassNames("icon-solid ", icon)} />
              <div className="symbol-name">
                {get(indicatorChart, "DisplayName")}
              </div>
              <div className="time-col">
                {Formatter.date(
                  get(indicatorChart, "AnnouncedAt"),
                  "MM/DD HH:mm"
                )}
              </div>
            </div>
          </div>
          <div className="modal-body-items">
            <IndicatorChartLegFilter canvasId={MODAL_INDICATOR_CANVAS_ID} />
          </div>
          <div className="modal-body-items chart-content">
            <IndicatorChart canvasId={MODAL_INDICATOR_CANVAS_ID} />
          </div>
          <div className="modal-body-items">
            <InfoTable
              list={infoTableColumns.sp_indicator_modal}
              data={symbolDetail}
              className="table-striped table-index-detail"
              wrapperCls="index-detail-table-row"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-bottom-btn-row">
          <div
            className="btn btn-outline ripple"
            data-izimodal-close
            onClick={() => onHide()}
          >
            閉じる
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default SpIndicatorChart
